module.exports = __webpack_public_path__ + "images/83c75a934a3f27bb32817eee8a0b6b7d.svg";